const SERVER_UPTIME_PCT = 100;
const NON_PROD_SERVER_UPTIME_PCT = 24;
const AVG_CPU_UTILIZATION_PCT = 39;
const PEAK_CPU_UTILIZATION_PCT = 39;
const AVG_RAM_UTILIZATION_PCT = 43;
const PEAK_RAM_UTILIZATION_PCT = 43;

export const INDUSTRIAL_AVERAGE_USAGE = {
    SERVER_UPTIME_PCT,
    NON_PROD_SERVER_UPTIME_PCT,
    AVG_CPU_UTILIZATION_PCT,
    PEAK_CPU_UTILIZATION_PCT,
    AVG_RAM_UTILIZATION_PCT,
    PEAK_RAM_UTILIZATION_PCT
};
